const trackingCode = process.env.VUE_APP_GOOGLE_ANALYTICS

if (trackingCode) {
  document.write(`<script async src="https://www.googletagmanager.com/gtag/js?id=${trackingCode}"></script>`)
  document.write(`<script>window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '${trackingCode}');</script>`)
}
